import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTheme } from "../../../themes/theming";
import BootstrapTable from 'react-bootstrap-table-next';
import '../index.css';
import { fetchDealerProgressPerLocation } from "../../../actions/dashboardAction";
import { AUTO_DEFAULT_FILTER } from "../../../AppConstant";

const ProgressPerLocation = (props) => {
    var I18n = require("react-redux-i18n").I18n;
    const { customHeight, dispatch, dealerOperations } = props;
    const [hasFetched, setHasFetched] = useState(false);
    const [data, setData] = useState([]);

    /** First audit formatter */
    const firstAuditFormatter = (cell, row) => {
        const colorMap = {
            PASSED: "circleSize success-act",
            ONGOING: "circleSize yellow-act",
            FAILED: "circleSize danger-act",
        };
        const color = colorMap[row?.firstAuditStatus] || "";

        return (
            <div title={row?.firstAuditStatus ? I18n.t('First Audit.' + row?.firstAuditStatus.toLowerCase()) : "Not Started"}>
                {row?.firstAuditStatus !== null ? (
                    <i className={"fa fa-circle " + color} />
                ) : (
                    <button style={{ backgroundColor: "#808080", lineHeight: 0.1 }} disabled></button>
                )}
            </div>
        );
    };

    /** Kaizen formatter */
    const kaizenFormatter = (cell, row) => {
        const colorMap = {
            COMPLETED: "circleSize success-act",
            ONGOING: "circleSize yellow-act",
        };

        const color = colorMap[row?.kaizenStatus] || "";

        return (
            <div title={row?.kaizenStatus ? I18n.t('kaizen.' + row?.kaizenStatus.toLowerCase()) : I18n.t('dashboardCards.NotStarted')}>
                {row?.kaizenStatus ? (
                    <i className={"fa fa-circle " + color} />
                ) : (
                    <button style={{ backgroundColor: "#808080", lineHeight: 0.1 }} disabled></button>
                )}
            </div>
        );
    };

    /** re-Audit formatter */
    const reAuditFormatter = (cell, row) => {
        const colorMap = {
            PASSED: "circleSize success-act",
            ONGOING: "circleSize yellow-act",
            FAILED: "circleSize danger-act",
        };

        const color = colorMap[row?.reAuditStatus] || "";

        return (
            <div title={row?.reAuditStatus ? I18n.t('reAudit.' + row?.reAuditStatus.toLowerCase()) : I18n.t('dashboardCards.NotStarted')}>
                {row?.reAuditStatus ? (
                    <i className={"fa fa-circle " + color} />
                ) : (
                    <button style={{ backgroundColor: "#808080", lineHeight: 0.1 }} disabled></button>
                )}
            </div>
        );
    };

    /** Audit status formatter */
    const auditStatusFormatter = (cell, row) => {
        const { auditStatus } = row;

        // Early return for null/undefined status
        if (!auditStatus) {
            return (
                <button style={{ backgroundColor: "#808080", lineHeight: 1.5, color: "white" }} disabled />
            );
        }

        // Status color mapping
        const statusColors = {
            PASSED: "#28a745",
            FAILED: "#e50000"
        };

        const backgroundColor = statusColors[auditStatus] || "#808080";
        const formattedStatus = auditStatus.charAt(0).toUpperCase() + auditStatus.slice(1).toLowerCase();

        return (
            <button
                style={{
                    backgroundColor,
                    lineHeight: 1.5,
                    color: "white",
                    textAlign: "center",
                    fontSize: "0.675rem",
                    border: "none",
                    borderRadius: "4px",
                    padding: "4px 8px"
                }}
                disabled
            >
                {I18n.t(`auditStatus.${formattedStatus}`)}
            </button>
        );
    }

    /** Dealer formatter for ellipsis on dealer name */
    const dealerFormatter = (cell, row) => {
        return (
            <div style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{row.dealerName}</div>
        );
    }



    /** Handler for API success callback */
    const onSuccess = (response) => setData(response);


    /** Handler for API failure callback */
    const onFailure = (error) => console.error("❌ Error while fetching list of video", error);

    const fetchProgressBarData = () => {
        try {
            if (!props.toolboxByType?.toolboxByType || props.toolboxByType.toolboxByType?.length === 0) {
                return;
            }

            const toolBoxList = props.toolboxByType?.toolboxByType;
            const cycleList = props.cycleDataList;

            if (!toolBoxList || toolBoxList?.length === 0 || !cycleList || cycleList?.length === 0) {
                console.warn("Required data is not ready yet.");
                return;
            }

            const initialToolBoxId = toolBoxList[toolBoxList?.length - 1];
            const initialCycle = cycleList[cycleList?.length - 1];

            if (!initialCycle?.cycle) {
                console.warn("Initial cycle format is missing.");
                return;
            }
            const [initialStartDate, initialEndDate] = initialCycle.cycle.split(" to ");
            const nmscCode = props.existingProps.userMdl.nmsc;
            const activeProgram = props.existingProps.userMdl.activeProgram;

            const data = {
                "userNmscCode": props.existingProps.userMdl.nmsc,
                "userLangCode": props.existingProps.userMdl.lang,
                "programList": [props.existingProps.userMdl.activeProgram],
                "nmscCode": props.existingProps.nmscFlag ? [nmscCode.toUpperCase()] : props.existingProps.nmscFilter,
                "brand": props.existingProps.brandFilter,
                "country": props.existingProps.countryFilter,
                "region": props.existingProps.regionFilter,
                "userId": props.existingProps.userMdl.username,
                "businessArea": props.existingProps.userMdl.businessAreaKey,
                "toolboxIDList": (props.existingProps.toolboxIDList?.length > 0) ? props.existingProps.toolboxIDList : [Number(initialToolBoxId?.packageMapPrimaryKey)],
                "startDate": props.existingProps.startDate !== "" ? props.existingProps.startDate : initialStartDate,
                "endDate": props.existingProps.endDate !== "" ? props.existingProps.endDate : initialEndDate,
                "dealerOperations":  dealerOperations?.length > 0 ? dealerOperations : (AUTO_DEFAULT_FILTER[activeProgram] || ['All'])
            }
            dispatch(fetchDealerProgressPerLocation(onSuccess, onFailure, data))
        } catch (error) {
            console.error("Error fetching progress bar data:", error);
        }
    }

    useEffect(() => {
        const toolBoxReady = props.toolboxByType?.toolboxByType?.length > 0;
        const cycleReady = props.cycleDataList?.length > 0;

        if (toolBoxReady && cycleReady && !hasFetched) {
            fetchProgressBarData();
            setHasFetched(true);
        }
    }, [props.toolboxByType?.toolboxByType, props.cycleDataList, hasFetched]);

    /** Required table columns in the table */
    const columns = [{
        dataField: "dealerName",
        text: I18n.t("Table.dealerName"),
        sort: true,
        style: { width: "9%", textAlign: "left" },
        headerStyle: { width: "9%", textAlign: "left" },
        formatter: dealerFormatter,
        title: true
    },
    {
        dataField: "dealerLocation",
        text: I18n.t("Table.DealerLocation"),
        sort: true,
        style: { width: "7%", textAlign: "left" },
        headerStyle: { width: "7%", textAlign: "left" },
        title: true
    },
    {
        dataField: "firstAuditStatus",
        text: I18n.t("dashboardCards.FirstAudit"),
        style: { width: "4.5%", marginRight: "3px" },
        formatter: firstAuditFormatter,
        headerStyle: { width: "5%", wordWrap: "break-word" },
    },
    {
        dataField: "kaizenStatus",
        text: I18n.t("Table.kaizen"),
        sort: true,
        style: { width: "4.5%", marginRight: "2px" },
        formatter: kaizenFormatter,
        headerStyle: { width: "4.5%" },
    },
    {
        dataField: "reAuditStatus",
        text: I18n.t("dashboardCards.ReAudit"),
        sort: true,
        style: { width: "5%", marginRight: "0px" },
        formatter: reAuditFormatter,
        headerStyle: { width: "6.2%", wordWrap: "break-word" },
    }, {
        dataField: "auditStatus",
        text: I18n.t("Table.auditStatus"),
        sort: true,
        style: { width: "5%", marginRight: "0px" },
        formatter: auditStatusFormatter,
        headerStyle: { width: "6.2%", wordWrap: "break-word" },
    }];

    return (
        <div className='toolboxImplNasCss' style={{ minWidth: "100%" }}>
            <div className={"large-widget-header left-align-header widget-header-" + props.theme.name} title={I18n.t('dashboardHeaders.ProgressPerLocationElement')}>
                {I18n.t('dashboard.ProgressPerLocation')}
            </div>

            <div style={{ height: customHeight ? customHeight : "300px", overflowY: "scroll", overflowX:"clip" }}>
                <BootstrapTable
                    keyField='actionPlanId'
                    noDataIndication={I18n.t('tabsDetails.noActionAvailable')}
                    data={data || []}
                    columns={columns}
                    hover
                    condensed
                    classes="sticky-header-table"
                    headerClasses="sticky-table-header"
                />
            </div>
        </div>
    );
}
const mapStateToProps = state => {
    return {
        user: state.loginReducer,
        activityToolBox: state.activityReducer,
        cycleDataList: state.dashboardReducer.cycleDataList,
        toolboxByType: state.leftNavReducer
    };
};
export default withRouter(connect(mapStateToProps)(withTheme(ProgressPerLocation)));

